var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ti-quiz-welcome ti-font-regular",
      on: { click: _vm.dismissWelcome },
    },
    [
      _c("picture", [
        _vm.welcomeHtml.assetImageLarge
          ? _c("source", {
              attrs: {
                srcset: `${encodeURI(_vm.welcomeHtml.assetImageLarge)}, 2x`,
                media: `(min-width: ${
                  _vm.welcomeHtml.assetImageMedium ? "1200px" : "768px"
                })`,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.welcomeHtml.assetImageMedium
          ? _c("source", {
              attrs: {
                srcset: `${encodeURI(_vm.welcomeHtml.assetImageMedium)}, 2x`,
                media: "(min-width: 768px)",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          staticClass: "ti-quiz-welcome-img",
          attrs: {
            src: encodeURI(
              _vm.welcomeHtml.assetImageSmall ||
                _vm.welcomeHtml.assetImageMedium ||
                _vm.welcomeHtml.assetImageLarge
            ),
            alt: _vm.welcomeHtml.assetBody,
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ti-quiz-welcome-content" }, [
        _c("h1", {
          staticClass: "ti-fs-md-56",
          class: [
            _vm.welcomeHtml.assetTextColor === "black"
              ? "ti-text-color-black"
              : "ti-text-color-white",
          ],
          domProps: { innerHTML: _vm._s(_vm.welcomeHtml.assetBody) },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "ti-btn mt-16 w-auto px-50",
            class: [
              _vm.welcomeHtml.assetTextColor === "black"
                ? "ti-btn-third bg-transparent"
                : "ti-btn-ghost",
            ],
            attrs: { "data-cbt": _vm.getDataCbtValue() },
            on: { click: _vm.dismissWelcome },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.welcomeHtml.assetButtonText) +
                "\n        "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }